import * as React from 'react';

import { IProject } from '../../modules/Projects/models';
import { Arrow } from '../Arrow';

import './index.scss';

interface IProps {
    project: IProject;
    index: number;
}

export const ProjectPreview: React.FC<IProps> = ({ project: { photo, name, category }, index }) => {
    const [isArrowOpen, setArrowOpen] = React.useState<boolean>(false);

    return (
        <div className="project_list-view">
            <div className="project_list-view-img">
                <img src={photo} alt="" />
            </div>
            <div
                className="project_list-view-details"
                onMouseEnter={() => setArrowOpen(true)}
                onMouseLeave={() => setArrowOpen(false)}
            >
                <h4 className="project_list-view-details-name">{name}</h4>
                <h5 className="project_list-view-details-type">{category.name}</h5>
                <Arrow direction="RIGHT" isOpen={isArrowOpen} />
            </div>
        </div>
    );
};
